module.exports = "<div class=\"col-md-6 col-md-offset-3\">\n  <h3>Bienvenido</h3>\n</div>\n"